import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule, SelectItem, DataTable } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { config } from '../../../../../environments/config';

import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

import { CandidateApplicationsService } from '../../services/candidate-applications/candidate-applications.service';

@Component({
  selector: 'app-candidate-applications',
  templateUrl: './candidate-applications.component.html',
  styleUrls: ['./candidate-applications.component.scss']
})
export class CandidateApplicationsComponent implements OnInit {
  @ViewChild('gb') searchFilter;
  @ViewChild('dt') dataTable: DataTable;

  public loading: boolean = true;
  public msgs: Message[] = [];
  public citations: any[];
  public showModule = true;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;

  public filters: any[];
  public formFilter: FormGroup;

  public first = 0;

  public es: any;

  constructor(
    public candidateApplicationsService: CandidateApplicationsService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    public hasPermissionService: HasPermissionService,
    public router: Router,
    public fb: FormBuilder
  ) {
    this.es = calendarES();
  }

  ngOnInit() {
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';
    this.createFormFilter();
  }

  createFormFilter(data:any = null) {
    data = data || {      
      offer_primary_area_filter: '',
      venue_id_filter: '',
      company_id: null,
    }

    this.formFilter = this.fb.group({
      offer_primary_area_filter: new FormControl(data.offer_primary_area_filter),
      venue_id_filter: new FormControl(data.venue_id_filter),
      company_id: new FormControl(data.company_id),
    });
  }

  public loadApplicationsLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;

    if (event.sortOrder === -1)
      this.sort =  '-' + event.sortField;
    else
      this.sort =  event.sortField;

    if (event.globalFilter)
      this.query = event.globalFilter;
    else
      this.query = undefined;

    this.sort = '-id';

    this.getApplications();
  }

  public getApplications() {
    this.loading = true;
    this.candidateApplicationsService.getApplications(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;
        this.citations = response.json().data;
        /* for (var i = 0; i < this.citations.length; i++) {
          this.citations[i].salary = this.getNumberValidation(this.citations[i].salary);
        } */
        if (response.json().meta.total > response.json().meta.total_filtered)
          this.totalRecords = response.json().meta.total_filtered;
        else
          this.totalRecords = response.json().meta.total;
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'error' } );
      }
    );
  }

  public filter(values) {
    this.page = 1;
    this.first = 0;

    /* var query = this.searchFilter.nativeElement.value;
    if (query != null && query != "")
        query = query.replace(/\s/g, "%");

    this.query = query; */

    this.filters = [];   

    if (values.offer_primary_area_filter)
      this.filters.push({'key': 'offer_primary_area_id', 'value': values.offer_primary_area_filter});

    if (values.venue_id_filter !== null && values.venue_id_filter !== '' && values.venue_id_filter !== undefined) 
      this.filters.push({'key': 'venue_id', 'value': values.venue_id_filter});  
    
    if ( values.company_id !== null && values.company_id !== '' && values.company_id !== undefined )
      this.filters.push({ 'key': 'company_id', 'value': values.company_id.id });

    this.getApplications();
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/candidate-applications/candidate-applications.component.ts